const config = {
  development: {
    environment: 'development',
    landingUrl: 'https://restaurant.dimorder.com',
  },
  beta: {
    environment: 'beta',
    landingUrl: 'https://restaurant.dimorder.com',
  },
  production: {
    environment: 'production',
    landingUrl: 'https://restaurant.dimorder.com',
  },
}

export default config[process.env.REACT_APP_ENV] || config[process.env.NODE_ENV] || config.development



// WEBPACK FOOTER //
// ./src/config.js